export default __webpack_public_path__ + "static/media/armaWallPaper.3a5c6d60.jpg";